import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import styled from "styled-components";

const PasswordRequirements = styled.div`
  margin-bottom: 16px;
  padding-left: 8px;
  font-size: 12px;
`;

const RequirementItem = styled.div`
  display: flex;
  align-items: center;
  margin: 4px 0;
  // @ts-ignore
  color: ${(props) => (props.$isMet ? "#52c41a" : "#ff4d4f")};

  .anticon {
    margin-right: 8px;
    font-size: 14px;
  }
`;

// Exported password validation regex - use this in all Form validation rules
export const PASSWORD_VALIDATION_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^+-])[A-Za-z\d@$!%*?&#^+-]{8,}$/;

function PasswordRequirementsList({ password }) {
  const requirements = [
    { text: "At least 8 characters", regex: /.{8,}/ },
    { text: "At least 1 uppercase letter", regex: /[A-Z]/ },
    { text: "At least 1 lowercase letter", regex: /[a-z]/ },
    { text: "At least 1 number", regex: /\d/ },
    { text: "At least 1 special character", regex: /[@$!%*?&#^+-]/ },
  ];

  const hasStartedTyping = password && password.length > 0;

  if (!hasStartedTyping) {
    return null;
  }

  const allRequirementsMet = requirements.every((requirement) => requirement.regex.test(password));

  if (allRequirementsMet) {
    return null;
  }

  return (
    <PasswordRequirements>
      {requirements.map((requirement) => {
        const isMet = requirement.regex.test(password);
        return (
          <RequirementItem key={requirement.text} $isMet={isMet}>
            {isMet ? <CheckCircleFilled /> : <CloseCircleFilled />}
            <span>{requirement.text}</span>
          </RequirementItem>
        );
      })}
    </PasswordRequirements>
  );
}

export default PasswordRequirementsList;
